import React from 'react'
import { useFormContext } from 'react-hook-form'
import useSessionStorage from '../../hooks/useSessionStorage'
import { initialFields } from '../../consts'

export default function Apellido2({ label, title, required = true }) {
  const {
    register,
    getValues,
    formState: { errors },
  } = useFormContext()

  const [storageData, setStorageData] = useSessionStorage(
    'app_data',
    initialFields
  )

  const handleChange = () => {
    setStorageData(getValues())
  }

  return (
    <div className="form-field">
      {title && <span>{title}</span>}
      <div className="form-group">
        <label htmlFor="MCCPERSTAG.TOMADOR.Apellido2">
          {label || 'Segundo apellido'}
        </label>
        <input
          type="text"
          id="MCCPERSTAG.TOMADOR.Apellido2"
          className={`form-control${
            errors.MCCPERSTAG?.TOMADOR.Apellido2 ? ' hasError' : ''
          }`}
          placeholder={label || 'Segundo apellido'}
          {...register('MCCPERSTAG.TOMADOR.Apellido2', {
            onChange: handleChange,
            required: required === true ? 'El apellido es obligatorio.' : false,
            pattern: {
              value: /^[a-zA-ZÀ-ÖØ-öø-ÿ ]+$/i,
              message: 'Has introducido caracteres no permitidos.',
            },
            maxLength: {
              value: 150,
              message: 'El apellido es demasiado largo.',
            },
          })}
        />
        {errors.MCCPERSTAG?.TOMADOR?.Apellido2 && (
          <div className="error">
            {errors.MCCPERSTAG.TOMADOR.Apellido2.message}
          </div>
        )}
      </div>
    </div>
  )
}
